import { Container, Row, Col } from 'react-bootstrap';
//import React, { useState } from 'react';
import React, { useEffect, useRef, useState } from 'react';
import '../css/contactus.css';
import Review from './review';

function ContactUs() {
  const [captcha, setCaptcha] = useState(generateCaptcha());
  //const [imageSrc, setImageSrc] = useState('img_clean_world_office.jpg'); // Default image
  const [userCaptcha, setUserCaptcha] = useState('');
  const [captchaError, setCaptchaError] = useState('');
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNo: '',
    email: '',
    subject: '',
    message: '',
    terms: false,
  });

  // useEffect(() => {
  //   const mediaQuery = window.matchMedia('(max-width: 768px)');

  //   const updateImageBasedOnScreenState = (e) => {
  //     if (e.matches) {
  //       setImageSrc('img_clean_world_office.jpg'); // Replace with your dimmed image path
  //     } else {
  //       setImageSrc('img_clean_world_office.jpg');
  //     }
  //   };

  //   // Set initial image based on the current state
  //   updateImageBasedOnScreenState(mediaQuery);

  //   // Add event listener for changes
  //   mediaQuery.addEventListener('change', updateImageBasedOnScreenState);

  //   // Cleanup on component unmount
  //   return () => {
  //     mediaQuery.removeEventListener('change', updateImageBasedOnScreenState);
  //   };
  // }, []);

  // Function to generate a random CAPTCHA
  function generateCaptcha() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let captcha = '';
    for (let i = 0; i < 6; i++) {
      captcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return captcha;
  }

  // Function to handle form input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (userCaptcha !== captcha) {
      setCaptchaError('Invalid CAPTCHA. Please try again.');
      return;
    }
    setCaptchaError('');
    if (!formData.terms) {
      alert('Please agree to the Terms & Conditions and Privacy Policy.');
      return;
    }

    const payload = {
      FullName: formData.fullName,
      PhoneNo: formData.phoneNo,
      EmailAddress: formData.email,
      EmailSubject:  `Contact Us - ${formData.subject}`,
      Message:
        `Full Name: ${formData.fullName}\n` +
        `Phone No: ${formData.phoneNo}\n` +
        `Email Address: ${formData.email}\n` +
        `Subject: ${formData.subject}\n` +
        `Message:\n${formData.message}`,
    };

    try {
      // TODO: Update this API endpoint to your own contact form API
      // For now, just simulating success
      console.log('Contact form data:', payload);
      
      // Uncomment and update this when you have your own API endpoint:
      /*
      const response = await fetch('YOUR_API_ENDPOINT_HERE', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        alert('Your message has been sent successfully!');
      } else {
        alert('There was an error sending your message. Please try again.');
      }
      */
      
      // Temporary success message
      alert('Your message has been received! We will contact you shortly.');
      setFormData({
        fullName: '',
        phoneNo: '',
        email: '',
        subject: '',
        message: '',
      });
      setUserCaptcha('');
      setCaptcha(generateCaptcha());
    } catch (error) {
      console.error('Error sending feedback:', error);
      alert('Failed to send feedback. Please try again.');
    }
  };

  // Function to refresh the CAPTCHA
  const refreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setUserCaptcha('');
    setCaptchaError('');
  };

  return (
    <Container className="my-5">
      {/* Preloader */}


      {/* Banner Section */}
      <div className="aboutus-banner">
        <picture>
          <source media="(max-width: 768px)" srcSet={'/img_clean_world_office.jpg'} />
          <img
            src={'/img_shoreham_pharmacy_old.png'}
            alt="About Us Banner"
            className="aboutus-banner-img"
          />
        </picture>
        <div className="aboutus-banner-overlay"></div>
        <div className="aboutus-banner-content">
          <h1>Contact Us</h1>
        </div>
      </div>


      {/* Contact cards displaying location, email, and phone information */}
      <Row className="contact-cards mt-5">
        <Col md={4}>
          <div className="contact-card contact-card-phone">
            <div className="contact-card-icon">
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <h3>Location</h3>
            <p>
              <a
                className="links"
                href="https://www.google.com/maps/search/?api=1&query=Chak+248+RB+Bismillahpur+Pakistan"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                Chak 248 RB Bismillahpur
                <br />
                Pakistan
              </a>
            </p>
          </div>
        </Col>
        <Col md={4}>
          <div className="contact-card">
            <div className="contact-card-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <h3>Send An Email</h3>
            <p>
              <a
                className="links"
                href="https://mail.google.com/mail/?view=cm&fs=1&to=services.cleanworld.sol@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <br></br>
                services.cleanworld.sol@gmail.com
              </a>
              <br></br>
            </p>
          </div>
        </Col>
        <Col md={4}>
          <div className="contact-card">
            <div className="contact-card-icon">
              <i className="fas fa-phone"></i>
            </div>
            <h3>Call Us</h3>
            <p style={{marginTop: '-24px'}}>
              <a
                className="links"
                href="tel:+923206686696"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <br></br>
                0320-6686696 [Call]
              </a>
              <br />
              <a
                className="links"
                href="https://wa.me/923206686696"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                0320-6686696 [WhatsApp]
              </a>
            </p>
          </div>
        </Col>
      </Row>

      {/* Form and map section */}
      <Row className="mt-5">
        <Col md={6} tabIndex={-1}>
          {/* Contact form for users to send messages */}
          <h2 className="h2-title">Send Us A Message</h2>
          <form className="contact-form" onSubmit={handleSubmit}>
            <Row className="form-group">
              <Col md={6} style={{
                marginBottom: window.innerWidth < 768 ? '15px' : '0px' // gap for small screens
              }} className="d-flex align-items-center">
                <label htmlFor="name" className="me-2">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="fullName"
                  className="form-control"
                  style={{ marginLeft: window.innerWidth >= 768 ? '20px' : '0px' }}
                  placeholder="Your Name"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col md={6} className="d-flex align-items-center">
                <label htmlFor="email" className="me-2">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Col>
            </Row>
            <Row className="form-group">
              <Col md={12} className="d-flex align-items-center">
                <label htmlFor="phone" className="me-2">Phone:</label>
                <input
                  type="text"
                  id="phone"
                  name="phoneNo"
                  className="form-control"
                  placeholder="Your Phone Number"
                  value={formData.phoneNo}
                  onChange={handleChange}
                  required
                />
              </Col>
            </Row>
            <Row className="form-group">
              <Col md={12} className="d-flex align-items-center">
                <label htmlFor="subject" className="me-2">Subject:</label>
                <select
                  id="subject"
                  name="subject"
                  className="form-control"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a subject</option>
                  <option value="General Inquiry">General Inquiry</option>
                  <option value="Support">Support</option>
                  <option value="Feedback">Feedback</option>
                </select>
              </Col>
            </Row>
            <Row className="form-group">
              <Col md={12} className="d-flex align-items-center">
                <label htmlFor="message" className="me-2">Message:</label>
                <textarea
                  id="message"
                  name="message"
                  className="form-control"
                  rows="4"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </Col>
            </Row>
            <Row className="form-group">
              <Col md={12} className="d-flex align-items-center">
                <label htmlFor="captcha" className="me-2">Enter CAPTCHA:</label>
                <div className="captcha-container d-flex align-items-center">
                  <div className="captcha-display me-2">{captcha}</div>
                  <button
                    type="button"
                    className="captcha-refresh-btn me-2"
                    onClick={refreshCaptcha}
                    aria-label="Refresh CAPTCHA"
                  >
                    🔄
                  </button>
                  <input
                    type="text"
                    id="captcha"
                    className="form-control"
                    placeholder="Enter CAPTCHA"
                    value={userCaptcha}
                    onChange={(e) => setUserCaptcha(e.target.value)}
                    required
                  />
                </div>
                {captchaError && <div className="captcha-error">{captchaError}</div>}
              </Col>
            </Row>
            <Row className="form-group1">
              <Col md={12} className="d-flex align-items-center">
                <input
                  type="checkbox"
                  id="terms"
                  name="terms"
                  className="me-2"
                  checked={formData.terms}
                  onChange={handleChange}
                  required
                />
                <p htmlFor="terms" className="mb-0">
                  I agree to the <a href="/terms-and-conditions" style={{ marginRight: "5px" }}> Terms & Conditions </a> and{" "}
                  <a href="/privacy-policy" style={{ marginLeft: "5px" }}> Privacy Policy</a>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <button type="submit" className="btn btn-primary">Submit</button>
              </Col>
            </Row>
          </form>
        </Col>
        <Col md={6} tabIndex={-1}>
          {/* Embedded Google Map showing the location */}
          <h2 className="h2-title">Our Location</h2>
          <iframe
            src="https://www.google.com/maps?q=Chak+248+RB+Bismillahpur+Pakistan&output=embed"
            width="100%"
            height="537px"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Col>
      </Row>

      {/* Review Section */}
      <Review />
    </Container>
  );
}

export default ContactUs;